export const SendOtpKey = () => ["SendOtp"];
export const ValidateOtpKey = () => ["ValidateOtp"];
export const GetInfoKey = () => ["GetInfo"];
export const GetInfoSignupKey = () => ["GetInfo"];
export const SetCivilRegistryKey = () => ["SetCivilRegistry"];
export const SetAddressFirstKey = () => ["SetAddressFirst"];
export const GetProvincesKey = () => ["GetProvinces"];
export const GetCivilRegistryKey = () => ["GetCivilRegistry"];
export const GetCustomerByCodeKey = () => ["GetCustomerByCode"];
export const GetLegalInfoKey = () => ["GetLegalInfo"];
export const ChangePasswordKey = () => ["ChangePassword"];   // ← جدید

// core/services/auth/queryKeys.ts
export const authKeys = {
    all: ["auth"] as const,
    userInfo: () => [...authKeys.all, "userInfo"] as const,
    legalInfo: () => [...authKeys.all, "legalInfo"] as const,
    changePassword: () => [...authKeys.all, "changePassword"] as const, // ← جدید
};

export const locationKeys = {
    all: ["location"] as const,
    provinces: () => [...locationKeys.all, "provinces"] as const,
};